import authority from './../authorityManage/authority.vue';
export default {
  components: {
    authority
  },
  methods: {
    handleOk() {
      this.$router.go(-1);
    }
  }
};